module.exports = __webpack_public_path__ + "img/MIS.bdd7164f.svg";